import styled from 'styled-components';

import { styledReset } from '@pkg/primitives';

import { tokens } from '../../../../tokens';

export const HeaderWrapper = styled.div<{ $leadingSpace: boolean }>`
    display: grid;
    grid-template-columns: 1fr auto;
    flex: 0 0 auto;
    // TODO: Remove 'margin-top' once we no longer need '$leadingSpace'.
    margin-top: ${({ $leadingSpace }) => ($leadingSpace ? tokens.spacing.tight + 'px' : 0)};
    padding-left: ${tokens.spacing.tight}px;
    padding-right: ${tokens.spacing.tight}px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        // TODO: Remove 'margin-top' once we no longer need '$leadingSpace'.
        margin-top: 0;
        padding-left: ${tokens.spacing.loose}px;
        padding-right: ${tokens.spacing.loose}px;
    }
`;

export const PrimaryColumn = styled.div``;
export const SecondaryColumn = styled.div``;

export const TitleWrapper = styled.div`
    display: flex;
    align-items: baseline;
`;

export const Title = styled.h1`
    ${styledReset.typography}
    font-family: 'Alliance No.1';
    font-size: 20px;
    font-weight: 700;
    letter-spacing: -0.03em;
    color: ${({ theme }) => theme.colors.white};

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 26px;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.desktopSmall}) {
        font-size: 32px;
    }
`;

export const Subtitle = styled.h2`
    ${styledReset.typography}
    margin-top: 0.6em;
    font-family: 'Alliance No.1';
    font-size: 16px;
    color: ${({ theme }) => theme.colors.grey};

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 18px;
    }
`;

export const MetaText = styled.p`
    ${styledReset.typography}
    margin-left: 10px;
    font-family: 'Alliance No.1';
    font-size: 14px;
    color: ${({ theme }) => theme.colors.grey};

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 16px;
    }
`;
